import { IOrderListItem } from "../../interfaces/IOrderLIstItem";
import * as ordersAPIUtil from "../../util/orders/ordersAPIUtil";
import { IOrderListResponse } from "../../interfaces/IOrderListResponse";
import MOrderListItem from "../../models/MOrderListItem";
import { OFilters } from "../state/ordersState";
import { IDocumentReference } from "../../interfaces/IDocumentReference";
import DocumentReference from "../../models/DocumentReference";

export const RECEIVE_ORDERS = "[Orders List] RECEIVE_ORDERS";
export const FETCH_ERROR = "[Orders List] FETCH_ERROR";
export const IS_LOADING = "[Orders List] IS_LOADING";
export const RECEIVE_STATUSES = "[Orders List] RECEIVE_STATUSES";
export const UPDATE_FILTERS = "[Orders List] UPDATE_FILTERS";
export const CLEAR_FILTERS = "[Orders List] CLEAR_FILTERS";
export const RECEIVE_DOCUMENTS = "[Orders List] RECEIVE_DOCUMENTS";
export const RECEIVE_META_DATA = "[Orders List] RECEIVE_META_DATA";
export const UPDATE_SELECTED_ORDERS = "[Orders selected orders] UPDATE_SELECTED_ORDERS";
export const UPDATE_PAYMENT_INFO = "[Orders payment data] UPDATE_PAYMENT_INFO";
export const RECEIVE_CURRENCY_EXCHANGE_RATES = "[Currency exchange data] RECEIVE_CURRENCY_EXCHANGE_RATES";


export const receiveOrders = (orders: IOrderListItem[], count: number) => ({
    type: RECEIVE_ORDERS,
    payload: orders,
    count
});

export const sendFetchError = () => ({
    type: FETCH_ERROR
});

export const isLoading = val => ({
    type: IS_LOADING,
    payload: val
});

export const receiveStatuses = statuses => ({
    type: RECEIVE_STATUSES,
    payload: statuses
});

export const receiveFilterUpdate = (filter: { [key: string]: any }) => ({
    type: UPDATE_FILTERS,
    payload: filter
});
export const updateSelectedOrder = (orders) => ({
    type: UPDATE_SELECTED_ORDERS,
    payload: orders
});
export const updatePaymentInfo = (data) => ({
    type: UPDATE_PAYMENT_INFO,
    payload: data
});

export const clearFilters = (statuses: string[]) => ({
    type: CLEAR_FILTERS,
    payload: statuses
});

export const receiveDocuments = (document: IDocumentReference) => ({
    type: RECEIVE_DOCUMENTS,
    document
});

export const receiveMetaData = (metadata) => ({
    type: RECEIVE_META_DATA,
    payload: metadata
});

export const receiveCurrencyExchangeRates = (data) => ({
    type: RECEIVE_CURRENCY_EXCHANGE_RATES,
    payload: data
});

export const fetchOrders = (limit: number = 50, offset: number = 0, order: string = "", orient: string = "asc", filters: OFilters = ordersAPIUtil.initialFilter) => dispatch => ordersAPIUtil.fetchOrders(limit, offset, order, orient, filters)
    .then(res => {
        const ordersResponse: IOrderListResponse = res.data;
        dispatch(receiveMetaData(ordersResponse.meta));
        const orderList: IOrderListItem[] = ordersResponse.data.map(individualOrder => {
            return new MOrderListItem(individualOrder);
        });

        const orderIds = orderList.map((orderItem: IOrderListItem) => orderItem.id);
        let orderLength = orderIds.length
        if (orderLength) {
            ordersAPIUtil.getDocuments(orderIds).then(res => {
                const { data } = res;
                const documents = data.map(individualDocument => new DocumentReference(individualDocument));
                const dispatchDocuments = (documents) => {
                    return new Promise((resolve, reject) => {
                        let lastDocument;
                        documents.forEach(document => {
                        dispatch(receiveDocuments(document));
                        lastDocument = document;
                        });
                        resolve(lastDocument);
                    });
                    };
                dispatchDocuments(documents).then(lastDocument => {
                    dispatch(receiveOrders(orderList, ordersResponse.meta.page_count));
                });
            })
        }else{
            dispatch(receiveOrders(orderList, ordersResponse.meta.page_count));
        }
    }).catch(error => {
        console.log("orders list error", error);
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });

export const fetchStatuses = () => dispatch => ordersAPIUtil.fetchOrderStatuses()
    .then(res => {
        const statusNames = res.data.map(statusObj => statusObj.name);
        dispatch(receiveStatuses(statusNames));
    }).catch(error => {
        console.log("Fetch Status Error", error);
        dispatch(sendFetchError());
    })
export const fetchCurrencyExchangeRates = () => dispatch => ordersAPIUtil.fetchCurrencyExchangeRates()
    .then(res => {
        if (res.data && res.data.length > 0)
            dispatch(receiveCurrencyExchangeRates(res.data));
    }).catch(error => {
        // Axios errors can include the Authorization header. Keep the
        // diagnostic useful without logging the error/request object.
        console.error("Customer Portal could not load currency exchange rates.");
        dispatch(sendFetchError());
    })
